import React from 'react';
import { Grid, Divider } from "@mui/material";
import { Box } from "@mui/system";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import NCRFormHeading from '../NCRFormHeading';
import NCRFormLabel from '../NCRFormLabel';
import NCRSelectField from '../NCRSelectField';
import NCRTextField from '../NCRTextField';

export default function IICA({ content, onChange }) {

  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&::placeholder": {
              fontSize: "14px",
              fontWeight: 400,
              color: "rgba(84, 84, 84, 1)",
              opacity: 1,
            },
          },
        },
      },
    },
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box sx={{height:"auto"}}>
          <Box sx={{ p: 3,height:"auto" }}>
            <Box>
              <NCRFormHeading isRequired={true} tooltipData={
                [
                  { description: "Actions taken to contain the issue temporarily and prevent it from affecting additional products or processes." },
                ]
              }>
                Implement Interim Containment Action
              </NCRFormHeading>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container alignItems="center">
                      <Grid item xs={2}>
                        <NCRFormLabel>Action:</NCRFormLabel>
                      </Grid>
                      <NCRSelectField
                        size="medium"
                        name="implement_interim_containment_action"
                        value={content.formData.implement_interim_containment_action}
                        onChange={handleInputChange}
                        options={content.lookupTypes?.IICAValue || []}
                        disabled={content.inputDisable}
                        error={!!content?.errors?.implement_interim_containment_action}
                      />
                    </Grid>
                  </Box>
                  {content.formData.implement_interim_containment_action === 'Other' &&
                    <Box sx={{ mb: 1 }}>
                      <Grid container alignItems="center">
                        <Grid item xs={2}>
                          <NCRFormLabel>Action:</NCRFormLabel>
                        </Grid>
                        <NCRTextField
                          size='small'
                          sx={{ width: '340px' }}
                          multiline
                          name="implement_interim_containment_action_other"
                          onChange={handleInputChange}
                          disabled={content.inputDisable}
                          value={content.formData.implement_interim_containment_action_other || ''}
                          error={!!content?.errors?.implement_interim_containment_action_other}
                          placeholder="Enter action"
                          maxLength={250}
                        />
                      </Grid>
                    </Box>
                  }
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Divider />
        </Box>
      </ThemeProvider >
    </>
  );
};
